import loadable from '@loadable/component';

/**
 * The drag-and-drop libraries volto-subblocks asks for.
 *
 * volto-form-block edits its fields through volto-subblocks, which loads
 * react-dnd as the lazy libraries `reactDnd` and `reactDndHtml5Backend`.
 * Volto registered those up to version 17; from 18 on it does not, and
 * editing any page with a form block failed with "Invalid lib or bundle
 * name reactDnd,reactDndHtml5Backend". Registered here, on the same versions
 * volto-subblocks depends on. Plain JS, so the lazy imports need no type
 * declarations.
 */
export default function install(config) {
  config.settings.loadables = {
    ...config.settings.loadables,
    reactDnd: loadable.lib(() => import('react-dnd')),
    reactDndHtml5Backend: loadable.lib(() => import('react-dnd-html5-backend')),
  };
  return config;
}
